import { create } from 'zustand';

import { UserMeDto } from '@cineamo/api/models/user/UserMeDto.types';

import { RoleName } from '@cineamo/api/constants/role-constants';

export interface UserState {
    user: UserMeDto | null | undefined;
    userType: RoleName[] | null;
    isLoggedIn: boolean | null;
    isLoading: boolean | null;
    isAdmin: boolean | null;
}

type UserStore = UserState & {
    setUser: (user: UserMeDto | null) => void;
    setIsLoading: (isLoading: boolean | null) => void;
    setIsAdmin: (isAdmin: boolean | null) => void;
};

const useUserStore = create<UserStore>((set) => ({
    user: undefined,
    userType: [],
    isLoggedIn: false,
    isLoading: null,
    isAdmin: null,
    setUser: (user: UserMeDto | null) => {
        set(() => ({
            user: user,
            isLoggedIn: !!user,
            userType: (user?.roles || []) as RoleName[],
            isLoading: user === undefined,
            isAdmin: user?.roles?.includes(RoleName.ADMIN) ?? false
        }));
    },
    setIsLoading: (isLoading: boolean | null) => {
        set(() => ({ isLoading }));
    },
    setIsAdmin: (isAdmin: boolean | null) => {
        set(() => ({ isAdmin }));
    },
    setUserType: (userType: RoleName[]) => {
        set(() => ({ userType }));
    }
    // No `logout`: this store is not persisted, so it dies with the document that sign-out navigates
    // away from. Its only two callers were SignOutButton and SideNavigationProfile, both in a `.then`
    // after a navigation had already been issued — code that could never run.
}));
export default useUserStore;
